<template>
  <div>
    <div class="modal-backdrop"></div>
    <div class="modal setting-accordian-modal">
      <div class="content">
        <div class="pull-right">
          <div class="btn-close" @click="toggleCloseModal"></div>
        </div>
        <div class="setting-accordian-wrapper">
          <div class="tab">
            <div class="accordion" role="tablist">
              <div class="mb-2">
                <div class="setting-accordian-item">
                  <b-button block v-b-toggle.accordion-1 class="accordian-btn"
                    >Branding <i class="fa fa-chevron-down"></i
                  ></b-button>
                </div>
                <b-collapse
                  id="accordion-1"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <div class="branding">
                    <div class="branding-modal-content">
                      <form @submit.prevent="handleSubmission">
                        <!-- <div class="branch-setting-website-scrap-wrapper">
                          <input
                            class="website-url"
                            type="text"
                            placeholder="put your website link"
                          />
                        </div> -->
                        <div class="brand-setting-main-wrapper">
                          <div class="brand-setting-inner-wrapper">
                            <div class="branding-item">
                              <span class="branding-item-title"
                                >Schriftart:</span
                              >

                              <div
                                class="font-type-input-wrapper"
                                v-click-outside="onBlurBrandFontType"
                              >
                                <input
                                  type="text"
                                  v-model="brandForm.fontType"
                                  required
                                  defaultValue="Helvetica Neue"
                                  @keyup="onKeyUpBrandFontType"
                                  @focus="onfocusBranchFontType"
                                  @paste="onPasteBrandFontType"
                                />

                                <div
                                  v-if="
                                    isVisibleFontTypeDropdown ||
                                    isCustomFontsModalVisible
                                  "
                                  class="font-type-list-wrapper"
                                >
                                  <div v-if="isCustomFontsModalVisible">
                                    <WorkflowBrandSettingCustomFontModal
                                      :brandings="brandForm"
                                      @close="toggleAddCustomFont(false)"
                                      @save="onSaveCustomFont"
                                      @handleFileChange="handleFileChange"
                                    />
                                  </div>
                                  <template v-if="!isCustomFontsModalVisible">
                                    <div
                                      v-for="(
                                        font, index
                                      ) in getFilteredFontList"
                                      :key="index"
                                      class="font-type-item"
                                      @click="onSelectFontType(font)"
                                    >
                                      {{ font.name }}
                                    </div>

                                    <div
                                      class="font-type-item"
                                      @click="toggleAddCustomFont(true)"
                                    >
                                      Add new
                                    </div>
                                  </template>
                                </div>
                              </div>
                            </div>
                            <div class="branding-item">
                              <span class="branding-item-title"
                                >Primäre Rundung:</span
                              >

                              <input
                                type="number"
                                min="0"
                                v-model="brandForm.primaryBordarRadius"
                                max="100"
                                required
                                defaultValue="0"
                              />
                            </div>
                            <div class="branding-item">
                              <span class="branding-item-title"
                                >Sekundäre Rundung:</span
                              >

                              <input
                                type="number"
                                min="0"
                                max="100"
                                required
                                v-model="brandForm.secondaryBordarRadius"
                                defaultValue="0"
                              />
                            </div>
                            <div class="branding-item">
                              <span class="branding-item-title"
                                >Schriftfarbe:</span
                              >
                              <input
                                type="color"
                                v-model="brandForm.textColor"
                              />
                            </div>
                            <div class="branding-item">
                              <span class="branding-item-title"
                                >Primäre Farbe:</span
                              >
                              <input
                                type="color"
                                v-model="brandForm.primaryBrandColor"
                              />
                            </div>
                            <!-- <div class="branding-item">
                                  <span class="branding-item-title"
                                    >Sekundäre Farbe:</span
                                  >
                                  <input
                                    type="color"
                                    v-model="brandForm.secondaryBrandColor"
                                  />
                                </div> -->
                          </div>
                          <div class="brand-setting-preview-wrapper">
                            <div class="preview-items-main">
                              <h4>Beispiele</h4>
                              <div class="branding-item">
                                <h1
                                  :style="{
                                    color: getFontColor,
                                    'font-family': getFontType,
                                  }"
                                  class="branding-item-preview-title"
                                >
                                  Ein Titel
                                </h1>
                                <p
                                  :style="{
                                    color: getFontColor,
                                    'font-family': getFontType,
                                  }"
                                  class="branding-item-preview-description"
                                >
                                  Beschreibungstext
                                </p>
                              </div>
                              <div class="branding-item">
                                <div
                                  :style="{
                                    color: getFontColor,
                                    'font-family': getFontType,
                                    background: getPrimaryBrandColor,
                                    'border-radius': getPrimaryBorderRadius,
                                  }"
                                  class="option-preview-button"
                                >
                                  Option 1
                                </div>
                              </div>
                              <div class="branding-item">
                                <div
                                  class="preview-box"
                                  :style="{
                                    color: getFontColor,
                                    'border-radius': getSecondaryBorderRadius,
                                    'font-family': getFontType,
                                  }"
                                >
                                  <img src="../../assets/img/user.svg" />
                                  <div>Option 2</div>
                                </div>
                              </div>
                              <div class="branding-item">
                                <Button
                                  disabled
                                  :style="{
                                    color: '#ffffff',
                                    'font-family': getFontType,
                                    background: getPrimaryBrandColor,
                                    'border-radius': getSecondaryBorderRadius,
                                  }"
                                  >Start</Button
                                >
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="save-btn-wrap">
                          <button class="brand-setting-save-button">
                            Speichern
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </b-collapse>
              </div>

              <div class="mb-1">
                <div class="setting-accordian-item">
                  <b-button block v-b-toggle.accordion-2 class="accordian-btn"
                    >Einstellungen <i class="fa fa-chevron-down"></i
                  ></b-button>
                </div>
                <b-collapse
                  id="accordion-2"
                  accordion="my-accordion"
                  role="tabpanel"
                >
                  <div class="api-setting">
                    <div class="api-setting-modal-content">
                      <div>
                        <label>API-Endpoint</label>
                        <input
                          type="text"
                          v-model="process.settings.apiEndpoint"
                          :disabled="!isUserHasAccess"
                          required
                          @blur="setAsyncExecution"
                        />
                      </div>
                      <div class="execution-wrapper" v-if="showAsyncInput">
                        <label class="heading">Ausführungsmodus</label>
                        <div class="execution-input-wrapper">
                          <label>Synchron</label>
                          <input
                            type="radio"
                            name="execution-input"
                            v-model="execution"
                            value="synchron"
                            class="execution-mode"
                            required
                          />
                          <label>Asynchron</label>
                          <input
                            type="radio"
                            name="execution-input"
                            v-model="execution"
                            value="asynchron"
                            class="execution-mode"
                            required
                          />
                        </div>
                      </div>
                      <div class="api-version">
                        <label>Formular version</label>
                        <GeneralDropdown
                          className="database-dropdown form-builder-version-dropdown"
                        >
                          <template v-slot:selectFilter>
                            <span class="database-dropdown-placeholder">{{
                              getFormBuilderLabel(process.settings.formBuilder)
                            }}</span>
                          </template>
                          <template v-slot:optionData>
                            <b-dropdown-item
                              v-for="api in formBuilderVersionList"
                              :key="api.label"
                              @click="setFormBulderVerison(api.value)"
                            >
                              {{ api.label }}
                            </b-dropdown-item>
                          </template>
                        </GeneralDropdown>
                      </div>
                      <div class="api-version">
                        <label>Formular style</label>
                        <GeneralDropdown
                          className="database-dropdown form-builder-version-dropdown"
                        >
                          <template v-slot:selectFilter>
                            <span class="database-dropdown-placeholder">{{
                              getFormStyleClassLabel(
                                process.settings.formStyleClass
                              )
                            }}</span>
                          </template>
                          <template v-slot:optionData>
                            <b-dropdown-item
                              v-for="style in formStyles"
                              :key="style.value"
                              @click="setFormStyleClass(style.value)"
                            >
                              {{ style.label }}
                            </b-dropdown-item>
                          </template>
                        </GeneralDropdown>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </div>
          </div>
        </div>

        <!-- custom fonts modal -->
        <div v-if="isLoading" class="loading-wrapper">
          <LoadingSpinner />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  isHexTooDark,
  isHexTooLight,
  getApiEndpointVersion,
} from '../../utils/helpers';
import GeneralDropdown from '../core/general-dropdown.vue';

import WorkflowBrandSettingCustomFontModal from '../WorkFlow/WorkflowBrandSettingCustomFontModal.vue';

import {
  getCustomFonts,
  saveCustomFonts,
} from '@/utils/helpers/WorkFlowHelpers.js';
import LoadingSpinner from '@/components/widgets/LoadingSpinner.vue';

export default {
  name: 'BrandSettingModel',
  data() {
    return {
      brandForm: {
        fontType: 'Helvetica Neue',
        primaryBordarRadius: 0,
        secondaryBordarRadius: 0,
        textColor: '#8f8f8f',
        primaryBrandColor: '#000000',
        secondaryBrandColor: '#000000',
      },
      formBuilderVersionList: [
        { value: 'v7', label: 'Version 7' },
        { value: 'v6', label: 'Version 6' },
        { value: 'v5', label: 'Version 5' },
        { value: 'v4', label: 'Version 4' },
      ],
      formStyles: [
        { value: 'form-floating', label: 'Label im Input' },
        { value: 'flex-top', label: 'Label über dem Input' },
        // { value: 'flex-left', label: 'Label neben dem Input' },
      ],
      fontCDNs: [],

      customFontsItems: [],
      fontListt: [
        { name: 'Helvetica Neue', type: 'preset' },
        { name: 'Roboto', type: 'preset' },
        { name: 'Open Sans', type: 'preset' },
        { name: 'sans-serif', type: 'preset' },
        { name: 'Orbitron', type: 'preset' },
        { name: 'Nunito', type: 'preset' },
      ],

      isCustomFontsModalVisible: false,
      execution: 'synchron',
      isVisibleFontTypeDropdown: false,
      isLoading: false,
    };
  },
  props: {
    isBrandSettingModelOpen: {
      type: Boolean,
      default: false,
    },
    process: {
      type: Object,
      default: () => {},
    },
    isUserHasAccess: { type: Boolean, default: true },
  },
  computed: {
    getFontColor() {
      return this.brandForm.textColor;
    },
    getFontType() {
      return this.brandForm.fontType;
    },
    getPrimaryBrandColor() {
      return this.brandForm.primaryBrandColor;
    },
    getSecondaryBrandColor() {
      return this.brandForm.secondaryBrandColor;
    },
    getPrimaryBorderRadius() {
      return this.brandForm.primaryBordarRadius + 'px';
    },
    getSecondaryBorderRadius() {
      return this.brandForm.secondaryBordarRadius + 'px';
    },
    showAsyncInput() {
      let flowRunnerVersion = getApiEndpointVersion(
        this.process?.settings?.apiEndpoint
      );
      if (flowRunnerVersion > 7 && this.isAdmin) {
        return true;
      }
      return false;
    },
    isAdmin() {
      return this.$store.state.isAdmin;
    },

    getFilteredFontList() {
      const fonts = this.brandForm.fontType.split(',').map((f) => f.trim());
      return [
        ...this.fontListt.filter((font) => !fonts.includes(font.name)),
        ...this.customFontsItems.map((font) => ({ ...font, type: 'custom' })),
        ...this.fontCDNs,
      ];
    },
  },
  methods: {
    toggleCloseModal() {
      this.process.settings.isAsync = this.execution === 'asynchron';
      this.$emit('close');
    },
    showToaster(message, title, variant) {
      this.$bvToast.toast(message, {
        title,
        variant,
      });
    },
    handleSubmission() {
      if (
        isHexTooDark(this.getPrimaryBrandColor) &&
        !isHexTooLight(this.getFontColor)
      ) {
        this.showToaster(
          'Wenn die Primärfarbe dunkel ist, sollte die Schriftfarbe hell sein',
          'Fehlerhaft !',
          'danger'
        );
        return;
      }
      this.$emit('saveBrandSettings', this.brandForm);
    },
    getFormBuilderLabel(version) {
      if (version && version.trim() !== '') {
        const versionObject = this.formBuilderVersionList.find(
          (el) => el.value === version
        );

        if (versionObject && Object.keys(versionObject).length > 0) {
          return versionObject.label;
        } else {
          return 'version not found';
        }
      } else {
        return 'select version';
      }
    },
    getFormStyleClassLabel(styleClass) {
      if (styleClass && styleClass.trim() !== '') {
        const styleClassIndex = this.formStyles.findIndex(
          (el) => el.value === styleClass
        );
        if (styleClassIndex > -1) {
          return this.formStyles[styleClassIndex].label;
        } else {
          return 'style not found';
        }
      } else {
        return 'select style';
      }
    },
    setFormBulderVerison(version) {
      this.process.settings.formBuilder = version;
    },
    setFormStyleClass(styleClass) {
      this.process.settings.formStyleClass = styleClass;
    },
    setAsyncExecution() {
      let flowRunnerVersion = getApiEndpointVersion(
        this.process?.settings?.apiEndpoint
      );
      if (flowRunnerVersion < 8) {
        this.process.settings.isAsync = false;
        this.execution = 'synchron';
      }
    },
    toggleAddCustomFont(isVisible = false) {
      setTimeout(() => {
        this.isCustomFontsModalVisible = isVisible;
        this.isVisibleFontTypeDropdown = !isVisible;
      }, 10);
    },

    async onSaveCustomFont(fontCDN) {
      this.fontCDNs = [{ name: 'Custom URL', value: fontCDN, type: 'url' }];

      this.isCustomFontsModalVisible = false;
      this.brandForm.fontType = this.fontCDNs[0]['name'];
      this.brandForm.fontInfo = fontCDN;
      this.brandForm.fontSource = this.fontCDNs[0]['type'];
    },

    onfocusBranchFontType() {
      this.isVisibleFontTypeDropdown = true;
    },
    onBlurBrandFontType() {
      this.isVisibleFontTypeDropdown = false;
    },
    onKeyUpBrandFontType(e) {
      const isFontsExistInList = this.getFilteredFontList.some((font) =>
        font.name.includes(e.target.value)
      );

      if (!e.target.value || isFontsExistInList) {
        this.brandForm.fontSource = 'preset';
      }
    },
    onPasteBrandFontType() {
      this.brandForm.fontSource = 'preset';
    },
    onSelectFontType(font) {
      if (font.type === 'preset') {
        if (
          this.brandForm.fontSource &&
          this.brandForm.fontSource != 'preset'
        ) {
          this.brandForm.fontType = '';
        }
        const fonts = this.brandForm.fontType
          ? this.brandForm.fontType.split(',').map((f) => f.trim())
          : [];

        fonts.push(font.name);
        const fontString = fonts.join(', ');
        this.brandForm.fontType = fontString;
      } else {
        this.brandForm.fontType = font.name;
        if (font.type == 'custom') {
          this.brandForm.fontInfo = font.font;
        } else {
          this.brandForm.fontInfo = font.value;
        }
      }
      this.brandForm.fontSource = font.type;
    },
    async loadCustomFonts() {
      try {
        this.isLoading = true;
        const response = await getCustomFonts();
        this.customFontsItems = response;
      } catch (error) {
        this.customFontsItems = [];
      } finally {
        this.isLoading = false;
      }
    },
    async reloadFonts() {
      try {
        this.loadCustomFonts();
      } catch (error) {
        //
      }
      this.isCustomFontsModalVisible = false;
    },
    async handleFileChange(event) {
      try {
        this.isLoading = true;
        const file = event.target.files[0];
        if (file) {
          const payload = {
            name: file.name,
            font: file,
          };
          const response = await saveCustomFonts(payload);
          await this.loadCustomFonts();

          const selectedFonts = this.customFontsItems.find(
            (font) => font.id == response.data.item_id
          );
          this.brandForm.fontType = selectedFonts.name;
          this.brandForm.fontInfo = selectedFonts.font;
          this.brandForm.fontSource = 'custom';
        }
      } catch (error) {
        //sth went wrong while uploading fonts
      } finally {
        this.isLoading = false;
      }

      this.isCustomFontsModalVisible = false;
    },
  },
  created() {
    if (this.process.style) {
      this.brandForm = this.process.style;
    }
    if (this.process?.settings?.isAsync !== undefined) {
      this.execution = this.process.settings['isAsync']
        ? 'asynchron'
        : 'synchron';
    }
    this.loadCustomFonts();
  },
  components: {
    GeneralDropdown,
    LoadingSpinner,
    WorkflowBrandSettingCustomFontModal,
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}
.heading {
  padding: 15px 15px 0px;
  text-align: center;
}
.modal {
  background: #ffffff;
  border-radius: 19px;
  box-shadow: 0 0 20px rgb(31 37 50 / 20%);
  display: block;
  text-align: left;
  font-family: 'Open Sans', open-sans, sans-serif;
  -webkit-font-smoothing: antialiased;
  font-size: 12px;
  line-height: 17px;
  color: #5f697a;
  left: 0;
  right: 0;
  margin: auto;
  top: 0;
  bottom: 0;
  min-width: 300px;
  max-width: 40%;
  width: 100%;
  max-height: 530px;
  height: 100%;
  position: absolute;
}

.modal.shift-right {
  right: 0%;
  top: 0%;
  height: 100%;
}

.content {
  background-color: #fff;
  width: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  text-align: center;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pull-right {
  float: right;
  margin-right: 15px;
  margin-top: 15px;
}
/**** */

.branding-modal-content,
.branding-modal-content * {
  box-sizing: border-box;
}

.branding-modal-content {
  padding: 10px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  border-top: 2px solid #fff;
}
.branding-modal-content .brand-title h1 {
  font-size: 25px;
  margin-bottom: 20px;
}

.brand-setting-main-wrapper {
  display: flex;
  margin: 0 -10px;
}

.brand-setting-main-wrapper > div {
  width: 50%;
  padding: 0 10px;
}
.branding-modal-content .branding-item-title {
  font-size: 14px;
  display: block;
  text-align: left;
  color: #222;
  margin-bottom: 8px;
  font-weight: 600;
}

.branding-modal-content select {
  width: 100%;
  padding: 5px 5px;
  outline: none;
  border: 1px solid #000000;
  background: transparent;
  border-radius: 4px;
  cursor: pointer;
}

.branding-modal-content .branding-item {
  margin-bottom: 16px;
}

.branding-modal-content input[type='number'] {
  width: 70px;
  border: 1px solid #000;
  border-radius: 4px;
  padding: 5px 8px;
  color: #000;
  outline: none;
}
.branding-modal-content input[type='color'] {
  width: 30px;
  height: 30px;
  padding: 0;
  border-radius: 6px;
  outline: none;
  border: 1px solid #0000;
  overflow: hidden;
  cursor: pointer;
}
.preview-items-main {
  padding: 10px;
  height: 100%;
  background: rgb(247 247 247 / 80%);
}

.preview-items-main h4 {
  font-size: 16px;
  color: #000000;
  font-weight: 600;
  margin-bottom: 20px;
}

.preview-items-main .branding-item-preview-title {
  font-size: 16px;
  text-align: left;
  display: block;
  margin-bottom: 10px;
  font-weight: 600;
}
.preview-items-main .branding-item-preview-description {
  text-align: left;
  margin-bottom: 20px;
}
.preview-items-main .branding-item button {
  outline: none;
  border: 1px solid transparent;
  border-radius: 4px;
  padding: 4px 16px;
  font-size: 14px;
}

.preview-items-main .branding-item {
  text-align: left;
}
.preview-items-main .preview-box {
  padding: 16px;
  font-size: 16px;
  min-height: 100px;
  border: 1px solid #e7e7e7;
  border-radius: 4px;
}

.preview-items-main .preview-box img {
  width: 34px;
  margin-bottom: 39px;
}

.brand-setting-save-button {
  cursor: pointer;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.951);
  border: 3px solid rgba(0, 0, 0, 0.916);
  background-color: rgba(0, 0, 0, 0.916);
  border-radius: 0.375em;
  font-weight: 400;
  line-height: 23px;
  padding: 0.6rem 1.6rem;
  font-size: 0.9375rem;
  margin-top: 25px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
}
.preview-items-main .option-preview-button {
  border-color: white;
  width: fit-content;
  height: fit-content;
  background: #ffffff;
  margin-right: 8px;
  margin-bottom: 15px;
  cursor: pointer;
  text-align: center;
  border: 1px solid rgb(221, 221, 221);
  outline: none;
  transition-property: -ms-transform, -webkit-transform, transform,
    background-color, border-color;
  transition-duration: 0.15s;
  padding: 10px 20px;
  min-width: 59px;
  font-size: 13px;
}

.start-dropdown ::v-deep .customDropdown {
  width: 100% !important;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  height: 37px;
  color: #464d5d;
  justify-content: space-between;
}

::v-deep .start-dropdown {
  width: 100%;
}
::v-deep .start-dropdown .dropdown-menu {
  width: 100%;
}
.branding-modal-content input[type='text'] {
  width: 100%;
  border: 1px solid #000;
  border-radius: 4px;
  padding: 5px 8px;
  color: #000;
  outline: none;
}
::v-deep .toast .toast-header button.close {
  margin-left: auto;
  margin-bottom: 0;
  font-size: 1.3rem;
  line-height: 0;
  color: #000;
  opacity: 0.5;
  border: none;
  background: transparent;
}
::v-deep .toast:not(.show) {
  display: block;
}

.setting-accordian-modal label {
  display: block;
  padding-top: 0;
  padding-bottom: 9px;
  margin-right: 10px;
  margin-bottom: 0px;
  font-size: 13px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  width: 100%;
}
.modal.setting-accordian-modal .content .api-setting input,
.modal.setting-accordian-modal .content .website-url {
  border-radius: 0;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  width: 100%;
  margin-bottom: 0;
  height: 37px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0px 15px 0px 15px;
}
.modal.setting-accordian-modal .api-setting .database-dropdown {
  border-radius: 0;
  background: #fff;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border-right: medium none;
  width: 100%;
  margin-bottom: 0;
  height: 37px;
  color: #464d5d;
  border: 1px solid #dee3e9;
  border-radius: 2px;
  font-size: 14px;
  font-weight: 400;
  line-height: 19px;
  margin: 0 0 20px;
  -webkit-font-smoothing: antialiased;
  -webkit-box-shadow: none;
  box-shadow: none;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0;
}
.modal.setting-accordian-modal
  .database-dropdown
  .database-dropdown-placeholder {
  color: #464d5d;
}
.modal.setting-accordian-modal .database-dropdown ::v-deep button {
  justify-content: space-between;
}

.modal.setting-accordian-modal
  .database-dropdown
  ::v-deep
  button
  .dropdown-toggle-icon {
  padding: 0;
}

.modal.setting-accordian-modal
  .database-dropdown.form-builder-version-dropdown
  ::v-deep
  .dropdown-menu {
  width: calc(100% - 5px);
  left: 2px !important;
}

.modal.setting-accordian-modal .database-select .selected-database-container {
  border: 1px solid #dee3e9;
  margin: 0 0 20px;
  height: 130px;
  overflow-y: auto;
}
.modal.setting-accordian-modal
  .database-select
  .selected-database-container
  .database-list-item {
  display: flex;
  justify-content: space-between;
  padding: 7px 8px 7px 8px;
  align-items: center;
}

.modal.setting-accordian-modal
  .database-select
  .selected-database-container
  .database-list-item
  i {
  cursor: pointer;
}

.setting-accordian-modal .collapse {
  width: auto !important;
}
.setting-accordian-modal .setting-accordian-wrapper {
  padding: 40px 20px 20px;
  width: 100%;
  max-width: 100%;
}

.setting-accordian-modal .tab {
  max-height: 450px;
  overflow: auto;
}

.setting-accordian-modal .tab::-webkit-scrollbar {
  display: none;
}
.setting-accordian-modal .setting-accordian-modal .content {
  text-align: left !important;
}
.setting-accordian-modal .setting-accordian-item {
  /* background: #f5f5f5;
  border-radius: 6px; */
}

.setting-accordian-modal .setting-accordian-item .btn.accordian-btn {
  border: none;
  color: #222;
  font-weight: 600;
  width: 100%;
  text-align: left;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 300ms ease-in-out;
  background: #eee;
  padding: 10px;
  border-radius: 6px;
  padding: 10px;
}
.setting-accordian-modal
  .setting-accordian-item
  .btn.accordian-btn.not-collapsed {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.setting-accordian-modal
  .setting-accordian-item
  .btn.accordian-btn.not-collapsed
  i {
  transform: rotate(180deg);
}
.setting-accordian-modal .setting-accordian-item .branding-modal-content {
  padding: 10px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  border-top: 2px solid #fff;
  background: #eee;
}
.setting-accordian-modal .setting-accordian-item .api-setting-modal-content {
  padding: 10px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  border-top: 2px solid #fff;
  background: #eee;
}

.setting-accordian-modal .branding-modal-content .brand-setting-save-button {
  padding: 4px 15px;
  font-size: 14px;
}
.setting-accordian-modal .save-btn-wrap {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}
.setting-accordian-modal .api-setting .api-version {
  margin-top: 10px;
}
.setting-accordian-modal
  .setting-accordian-modal
  .api-setting
  .api-setting-modal-content {
  padding: 10px;
  border-bottom-left-radius: 6px;
  border-bottom-right-radius: 6px;
  border-top: 2px solid #fff;
  padding: 10px;
  background: #eee;
  box-sizing: border-box;
}

.setting-accordian-modal .execution-mode {
  width: 14px !important;
  height: 14px !important;
}
.setting-accordian-modal .execution-input-wrapper {
  display: flex;
  justify-content: start;
  align-items: center;
  gap: 10px;
}

.setting-accordian-modal .execution-wrapper .execution-input-wrapper input,
.setting-accordian-modal .execution-wrapper .execution-input-wrapper label {
  margin: 0 0 20px !important;
}
.setting-accordian-modal .execution-wrapper .execution-input-wrapper label {
  padding: 0 !important;
  width: unset !important;
}
.setting-accordian-modal .execution-wrapper .heading {
  margin-top: 10px;
}

.setting-accordian-modal .font-selector {
  width: 100%;
}
.setting-accordian-modal .font-type-input-wrapper {
  position: relative;
}

.setting-accordian-modal .font-type-list-wrapper {
  position: absolute;
}
.setting-accordian-modal .font-type-item {
  padding: 8px 8px;
  text-align: start;
  color: #000;
}
.setting-accordian-modal .font-type-item:hover {
  background-color: #e7e7e7;
  cursor: pointer;
}
.setting-accordian-modal .font-type-list-wrapper {
  background-color: white;
  box-shadow: rgba(31, 37, 50, 0.14) 0px 2px 35px,
    rgba(76, 86, 103, 0.2) 0px 0px 0px 1px;
  border-radius: 4px;
  width: 100%;
  max-height: 250px;
  overflow: scroll;
  margin-top: 4px;
}

.setting-accordian-modal .loading-wrapper {
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  z-index: 100;
}

.setting-accordian-modal ::v-deep .loading-wrapper .progress-icon-wrapper {
  position: unset;
}
</style>
